export class MsgConstants {
  static readonly INVITE_ADMIN_USER_EXIST = 'Invited admin user(s) already exists: ';
}
